import React from 'react';
import { useSelector } from 'react-redux';
import '../styles/activity-indicator.css';

/**
 * Global ActivityIndicator Component
 * Displays a full-screen loading overlay when isLoading is true
 * Controlled via Redux store (loader.showHideLoaderInState)
 */
const ActivityIndicator = () => {
  const isLoading = useSelector(state => state.loader?.showHideLoaderInState);

  if (!isLoading) {
    return null;
  }

  return (
    <div className='activity-indicator-overlay'>
      <div className='activity-indicator-content'>
        <div className='spinner'></div>
      </div>
    </div>
  );
};

export default ActivityIndicator;
